import {
	GET_OPERATORS,
	SET_FORM_STATE
} from '../actions/SettingsActions.js';

const initialState = {
	operators: [],
	formState: {
		isValid: false,
		values: {},
		touched: {},
		errors: {},
	}
};

const usersReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_OPERATORS: {
						return {
							...state,
							operators: action.operators
						};
					}
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					default: {
						return state;
					}
	}
};

export default usersReducer;
